export const dummyRequest = async onSuccess => {
    setTimeout(() => {
        onSuccess('ok');
    }, 0);
};
